import { useEffect, useState } from "react";
import { trackEvent } from "@/lib/track";

const TRACKED = "mulankan_install_tracked";

let deferred = null;
const EVT = "mulankan:installable";

export const isIOSDevice = () => /iPhone|iPad|iPod/i.test(navigator.userAgent)
  || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isMobileDevice = () => isIOSDevice() || /Android/i.test(navigator.userAgent);
export const isInstalled = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

export function setupInstall() {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e;
    window.dispatchEvent(new Event(EVT));
  });
  window.addEventListener("appinstalled", () => {
    deferred = null;
    window.dispatchEvent(new Event(EVT));
    localStorage.setItem(TRACKED, "1");
    trackEvent("android_install");
  });
  if (isInstalled() && !localStorage.getItem(TRACKED)) {
    localStorage.setItem(TRACKED, "1");
    trackEvent(isIOSDevice() ? "iphone_install" : "android_install");
  }
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
  }
}

export function useInstall() {
  const [, bump] = useState(0);
  useEffect(() => {
    const on = () => bump((n) => n + 1);
    window.addEventListener(EVT, on);
    return () => window.removeEventListener(EVT, on);
  }, []);
  const install = async () => {
    if (!deferred) return false;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    deferred = null;
    window.dispatchEvent(new Event(EVT));
    return outcome === "accepted";
  };
  return { installed: isInstalled(), canPrompt: !!deferred, ios: isIOSDevice(), install };
}
